import React, { useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Main from './screens/Main';
import Dashboard from './screens/Dashboard';
import { AssetListElement } from './types/AssetList';
import { GlobalsContext } from './store/Globals';
import FormScreen from './screens/Form';
import UpdateTypeFormScreen from './screens/UpdateTypeForm';
import TxFormScreen from './screens/TxForm';
import DynamicTxFormScreen from './screens/DynamicTxForm';
import ListScreen from './screens/List';
import ItemScreen from './screens/Item';
import { TransactionListElement } from './types/TransactionList';

const Routes: React.FC = ({ children }) => {
  const globals = useContext(GlobalsContext);

  const getAssetRoutes = (item: AssetListElement) => [
    <Route
      exact
      key={`create-${item.tag}`}
      path={`/${item.tag}/create`}
      render={() => <FormScreen asset={item} />}
    />,
    <Route
      exact
      key={`edittype-${item.tag}`}
      path={`/${item.tag}/edit`}
      render={() => <UpdateTypeFormScreen asset={item} />}
    />,
    <Route
      exact
      key={`editasset-${item.tag}`}
      path={`/edit/${item.tag}/:key`}
      render={() => <FormScreen asset={item} />}
    />,
    <Route
      exact
      key={`list-${item.tag}`}
      path={`/${item.tag}/list`}
      render={() => <ListScreen asset={item} />}
    />,
    <Route
      exact
      key={`listkey-${item.tag}`}
      path={`/${item.tag}/list/:key`}
      render={() => <ListScreen asset={item} />}
    />,
  ];

  const getTransactionRoutes = (item: TransactionListElement) => [
    <Route
      exact
      key={`route2${item.tag}`}
      path={`/${item.tag}/transaction`}
      render={() => <TxFormScreen tx={item} />}
    />,
  ];

  const getDynamicTransactionRoutes = (item: TransactionListElement) => [
    <Route
      exact
      key={`route2${item.tag}`}
      path={`/${item.tag}/transaction`}
      render={() => <DynamicTxFormScreen tx={item} />}
    />,
  ];

  return (
    <>
      {children}
      <Switch>
        <Route exact path="/" component={Main} />
        <Route exact path="/dashboard" component={Dashboard} />

        {globals.assetList
          ? globals.assetList.map((item) => getAssetRoutes(item))
          : null}

        {globals.transactionList
          ? globals.transactionList.map((item) => getTransactionRoutes(item))
          : null}

        {globals.standardTxList
          ? globals.standardTxList
              .filter(
                (tx) =>
                  tx.tag === 'createAssetType' || tx.tag === 'deleteAssetType',
              )
              .map((item) => getDynamicTransactionRoutes(item))
          : null}
        <Route exact path="/show/:key" component={ItemScreen} />
      </Switch>
      <ToastContainer autoClose={6000} />
    </>
  );
};

export default Routes;
